import { render, staticRenderFns } from "./MessageNotice.vue?vue&type=template&id=c1a8163e&scoped=true"
import script from "./MessageNotice.vue?vue&type=script&lang=js"
export * from "./MessageNotice.vue?vue&type=script&lang=js"
import style0 from "./MessageNotice.vue?vue&type=style&index=0&id=c1a8163e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a8163e",
  null
  
)

export default component.exports